import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Router from './router/Routes';
import './index.scss';

// import { IntlProvider } from 'react-intl';
// import zh_CN from './i18/zh_CN';
// import en_US from './i18/en_US';

// const langMap = {
//   'zh': zh_CN,
//   'en': en_US
// };

// const localeI18 = 'zh'
// if (localStorage.getItem("locale")) {
//   localeI18 = localStorage.getItem("locale") + ''
// }

ReactDOM.render(
    // <IntlProvider locale={localeI18} messages={langMap[localeI18]}>
    <Router />,
    // </IntlProvider>,
    document.getElementById('root') as HTMLElement
  )



// WEBPACK FOOTER //
// ./src/index.tsx